export default {
  methods: {
    // Returns full address from patient object
    fullAddress(patient_object) {
      return (
        patient_object.address +
        " " +
        patient_object.zipcode +
        " " +
        patient_object.city
      );
    },

    // Returns the initials of the given name
    getInitials(name) {
      return name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);
    },

    // Translate product model
    getTranslatedProductModel(model) {
      const obj = {
        CORSET: "CORSET",
        LIFT: "VERTICALISATEUR",
        LOWER_LIMB_ORTHOSIS: "ORTH M INF",
        MOLDED_SEAT: "SIEGE MOULE",
        NECK_BRACE: "MINERVE",
        OTN: "OTN",
        POSITIONING_SEAT: "SELLE POS",
        RETOUCHING_REPAIR: "RETOUCHE/REPARATION",
        SEAT: "SELLE",
        UPPER_LIMB_ORTHOSIS: "ORTH M SUP",
      };
      return obj[model];
    }
  }
};
